<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close :loading="loading">
			<template #default>
				<el-form ref="form" :model="form" label-width="80px" size="mini">
					<el-form-item label="流程名称" required>
						<el-select v-model="form.sonflowids" placeholder="请选择">
							<el-option v-for="item in sonflowoptions" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="发起人员" required>
						<el-input readonly v-model="form.authtext" placeholder="">
							<el-button slot="append" icon="el-icon-search" @click="authShow"></el-button>
						</el-input>
					</el-form-item>
				</el-form>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="danger" content="流程模拟" @click="flowsimulate"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
		<authIndex v-if="authModal" :extra="extra" @submit="authsubmit" @back="authback" />
		<flowsimulate-index :flowsimulatedata="flowsimulatedata" ref="flowsimulateIndex" />

	</div>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import flowsimulateIndex from '@_system/components/forms/window/flowsimulate/index.vue'
	import authIndex from '@_system/components/forms/auth/sonflow.vue'
	export default {
		mixins: [modalMixins],
		props: {
			rows: {
				default: () => {
					return []
				}
			},
			moduleName: {
				default: () => {
					return null
				}
			},

		},
		data() {
			return {
				loading: false,
				authModal: false,
				modal_title: '选择子流程',
				modal_width: 600,
				modal_height: 500,
				flowsimulatedata: [],
				currentrow: null,
				sonflowoptions: [],
				dataid: [],
				extra: {
					formid: 0,
					formitemtype:['staff']
				},
				form: {
					authtext: "2",
					auth: null
				}

			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_init() {
				this.loading = true
				this.form = {
					sonflowids: null,
					authtext: this.$store.state.system.user.name,
					auth: {
						auth:{
							staff:[{
								active:true,
								departmentid:this.$store.state.system.user.departmentid,
								departmentname:this.$store.state.system.user.department,
								id:this.$store.state.system.user.id,
								name:this.$store.state.system.user.name,
							}]
						}
					}
				}
				let dataid = []
				this.rows.forEach((item) => {
					dataid.push(item.id)
				})
				this.dataid = dataid
				this.$api.flow.getSonflow(0, {
					moduleName: this.moduleName
				}).then((res) => {
					let sonflowoptions = []
					res.forEach((item) => {
						this.extra.formid = item.formid
						item.value = item.id
						item.label = item.name
						sonflowoptions.push(item)
					})
					this.sonflowoptions = sonflowoptions
					this.loading = false
				}, () => {
					this.loading = false
				})
			},
			operateButtonClickEvent(e) {
				if (this[e.code]) {
					this[e.code](e.data)
				}
			},
			verifyForm() {
				let flowinfo = this.sonflowoptions.find((item) => {
					return item.id == this.form.sonflowids
				})
				if (!flowinfo) {
					this.$message.error('请选择流程')
					return false
				}
				if (!this.form.auth) {
					this.$message.error('请选择执行人员')
					return false
				}
				return flowinfo
			},
			authsubmit(e) {
				let name = []
				for (let i in e.data) {
					e.data[i].forEach((item) => {
						name.push(item.name)
					})
				}
				
				this.$set(this.form,'auth',{auth:e.data})
				this.$set(this.form,'authtext',name.join(','))
				//console.log(this.form,123123)
	
			},
			authback() {
				this.authModal = false
			},
			authShow() {
				console.log(this.form)
				this.extra.value = this.form.auth
				this.authModal = true
			},
			flowsimulate() {
				let flowinfo = this.verifyForm()
				if (!flowinfo) {
					return false
				}
				let handle = this.$loading()
				fetch(window.config.baseURL + '/' + window.config.app +
					'/flowprogress/simulateflow/' + flowinfo.controll, {
						method: "post",
						headers: {
							'Content-Type': 'application/json',
							'token': window.localStorage.getItem(this.$store.state.token)
						},
						body: JSON.stringify({
							dataid: this.dataid[0],
							flowid: this.form.sonflowids,
							auth: this.form.auth
						})
					}).then((response) => {
					if (!response.ok) {
						this.$loadingclose(handle)
						throw new Error('请求错误')
					}
					return response.json()

				}).then((res) => {
					if (res.code != 200) {
						this.$message.error(res.msg)
					} else {
						console.log(res)
						this.flowsimulatedata = res.data
						this.$refs.flowsimulateIndex.modal_show()
					}
					this.$loadingclose(handle)
				}, (e) => {
					this.$loadingclose(handle)
					this.$message.error(e.msg)
				}).catch((e) => {
					this.$loadingclose(handle)
					this.$message.error(e.msg)
				})
			},
			submit() {
				let flowinfo = this.verifyForm()
				if (!flowinfo) {
					return false
				}
				this.dataid.forEach((item) => {
					this.send(item, flowinfo)
				})
			},
			send(dataid, flowinfo) {
				let handle = this.$loading()
				fetch(window.config.baseURL + '/' + window.config.app +
					'/flowprogress/sonflow/' + flowinfo.controll, {
						method: "post",
						headers: {
							'Content-Type': 'application/json',
							'token': window.localStorage.getItem(this.$store.state.token)
						},
						body: JSON.stringify({
							dataid: dataid,
							auth: this.form.auth,
							sonflowids: [this.form.sonflowids]
						})
					}).then((response) => {
					if (!response.ok) {
						this.$loadingclose(handle)
						throw new Error('请求错误')
					}
					return response.json()

				}).then((res) => {
					if (res.code != 200) {
						this.$message.error(res.msg)
					} else {
						this.$message.success('操作成功')
						this.modal_cancel()
					}
					this.$loadingclose(handle)
				}, (e) => {
					this.$loadingclose(handle)
					this.$message.error(e.msg)
				}).catch((e) => {
					this.$loadingclose(handle)
					this.$message.error(e.msg)
				})
			},
			reset() {
				//this.init()
			}
		},
		components: {
			flowsimulateIndex,
			authIndex
		}
	}
</script>